module.exports = __webpack_public_path__ + "img/JAOC_POP_Crust_oval.3e3f9943.png";